import { connect } from 'react-redux';
import { setDocumentDataUrl } from '../../redux/actions/rootAction';
import React from 'react';
import II18 from '../translate/II18';
import PropTypes from 'prop-types';
import { gaeList } from '../requestedDocuments/ga';
import Uploader from './Uploader';

const mapStateToProps = (state, ownProps) => ({
  recipientRequestId: state.recipientRequestId,
  cameraMode: state.cameraMode,
  updateCameraMode: ownProps.cameraMode,
  scannedDocuments: state.scannedDocuments,
  requestedDocuments: state.requestedDocuments
});

const mapDispatchToProps = dispatch => ({
  setDocumentDataUrl: (documentId, pageId, dataUrl) =>
    dispatch(setDocumentDataUrl(documentId, pageId, dataUrl))
});

class ImageDocumentUploader extends React.Component {
  addPagesToDocument(docId, urls) {
    gaeList('ADD_PAGES_TO_DOCUMENT');
    this.props.setDocumentDataUrl(docId, '', urls);
  }

  render() {
    const document = this.props.requestedDocuments.get(this.props.documentId);
    const noRecognition =
      document &&
      document.attributes &&
      document.attributes.documentRecognition === false;

    /* update */
    return (
      <Uploader
        {...this.props}
        noRecognition={noRecognition}
        onImageLoaded={(documentId, imagesArray) => {
          if (imagesArray) {
            this.addPagesToDocument(documentId, imagesArray);
            this.props.onAfterAddImages &&
              this.props.onAfterAddImages(documentId);
          } else {
            if (noRecognition) {
              if (window.utils.isLoadedImageTooSmall()) {
                this.$f7.dialog.alert(
                  II18.get('cropper_is_to_small_message'),
                  II18.get('dialog_warning')
                );
              } else {
                this.addPagesToDocument(documentId, [
                  window.utils.processLoadedImageToResize()
                ]);
                this.props.onAfterAddImages &&
                  this.props.onAfterAddImages(documentId);
              }
            } else {
              this.props.onBeforeAddImages &&
                this.props.onBeforeAddImages(documentId);
            }
          }
        }}
      />
    );
  }
}

ImageDocumentUploader.propTypes = {
  requestedDocuments: PropTypes.object,
  setDocumentDataUrl: PropTypes.func,
  onAfterAddImages: PropTypes.func,
  onBeforeAddImages: PropTypes.func,
  documentId: PropTypes.string
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageDocumentUploader);
